<template>
    <div class="custom-select" ref="customSelect">
        <div @click="showSelectOptions = !showSelectOptions"
            :class="['select-selected', {'empty-title': selected && selected[title].trim() == ''}]"
        >
            {{ selected[title] || 'Empty Title' }}
        </div>
        <div v-if="showSelectOptions" class="select-items">
            <div v-for="option in options"
                :class="['option', {'active-option': option[value] == selected[value]}, {'empty-title': option && option[title].trim() == ''}]"
                @click="selectOption(option)"
            >
                {{ option && option[title].trim() !== '' ? option[title] : 'Empty Title' }}
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'VSelect',
    props: {
        options: {
            type: Array,
            default: []
        },
        defaultFirstOption: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: 'value'
        },
        title: {
            type: String,
            default: 'title'
        },
        setDefaultValue: {},
    },
    data() {
        return {
            selected: {[this.title]: 'Select an option', [this.value]: null},
            showSelectOptions: false,
        }
    },
    mounted() {
        if (this.defaultFirstOption) {
            this.selected = this.options[0]
            this.selectOption(this.selected)
        }

        if (this.setDefaultValue) {
            const filterCorrectOption = this.options.find(opt => opt[this.value] == this.setDefaultValue)
            this.selected = filterCorrectOption
        }

        window.addEventListener('click', e => {
            try { if (!(e.target?.classList?.contains('custom-select') || this.$refs.customSelect?.contains(e.target))) this.showSelectOptions = false } catch(e) {}
        })
    },
    watch: {
        defaultFirstOption(val) {
            if (val) { this.selected = this.options[0] }
        },
        options(val) {
            if (val && val.length) this.selected = val[0]
        }
    },
    methods: {
        selectOption(val) {
            this.selected = val
            this.$emit('selectHandler', this.selected[this.value])
            this.showSelectOptions = false
        }
    }
}
</script>

<style lang="scss">
.custom-select {
    position: relative;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;

    .select-items, .select-selected {
        border: 0.5px solid var(--outline);
        background-color: var(--primary-bg);
        border-radius: 10px;
    }

    .select-selected {
        padding: 3px 10px;
        cursor: pointer;
    }

    .select-items {
        position: absolute;
        bottom: 0;
        transform: translateY(100%);
        width: 100%;
        max-height: 250px;
        overflow-y: auto;
        z-index: 1;
        background-color: var(--primary-bg);
        border: 0.5px solid var(--outline);
        border-radius: 10px;

        .option {
            border-radius: 10px;
            cursor: pointer;
            padding: 3px 10px;

            &.active-option {
                background-color: var(--accent);
                &:hover {
                    background-color: var(--accent);
                }
            }
            &:hover {
                background-color: var(--hover);
            }
        }
    }
    .empty-title {
        color: #FF8A00;
    }
}
</style>